import React from 'react';
import { getError } from 'helpers/errors';
import { sendPurchaseInvoice } from '../../api';

export default class SendPurchaseInvoiceButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSent: false,
      error: '',
    };
  }

  async sendInvoice(id) {
    try {
      const { status } = await sendPurchaseInvoice(id);
      if (status === 200) {
        this.setState({
          isSent: true,
          error: '',
        });

        return;
      }
      throw new Error('');
    } catch (err) {
      const error = getError(err);
      this.setState({
        isSent: false,
        error:
          error || `An error occured sending the invoice for purchase #${id}`,
      });
    }
  }

  render() {
    const { purchaseId, email } = this.props;
    const { isSent, error } = this.state;
    return purchaseId && email ? (
      <React.Fragment>
        <button
          onClick={() => this.sendInvoice(purchaseId)}
          className="btn btn-primary"
          disabled={isSent}
        >
          Email Invoice to {email}
        </button>
        {isSent ? (
          <span className="text-success mar-l">Invoice has been sent.</span>
        ) : null}
        {error ? <span className="text-danger mar-l">{error}</span> : null}
      </React.Fragment>
    ) : null;
  }
}
